import useGlobalContext from "@src/globalContext/hooks/useGlobalContext";

const useUserIsRegistered = () => {
  const { userExtension } = useGlobalContext();

  return userExtension != null;
};

export default useUserIsRegistered;
